function isFullyVisible(element, container) {
  var elementRect = element.getBoundingClientRect();
  var containerRect = container.getBoundingClientRect();

  return (
    elementRect.top >= containerRect.top &&
    elementRect.left >= containerRect.left &&
    elementRect.bottom <= containerRect.bottom &&
    elementRect.right <= containerRect.right
  );
}

// gallery-thumb-nav.js
if (!customElements.get('gallery-thumb-nav')) {
  customElements.define('gallery-thumb-nav', 
    class GalleryThumbNav extends HTMLElement {
      constructor() {
          super(); 
          this.thumbnailList = this.parentElement.querySelector('.thumbnail-list');
          this.thumbnails = this.thumbnailList.querySelectorAll('.thumbnail-list__item');
          this.nextThumb = null;
          this.prevThumb = null;
          if (this.getAttribute('name') == 'next') { 
              this.pair = this.parentElement.querySelector('gallery-thumb-nav[name="previous"]');
          } else if (this.getAttribute('name') == 'previous') {
              this.pair = this.parentElement.querySelector('gallery-thumb-nav[name="next"]');
          }
          this.init();
    
          this.addEventListener('click', e => {
              if (this.hasAttribute('disabled')) return;
              if (this.getAttribute('name') == 'next' && this.nextThumb) {
                  this.nextThumb.querySelector('.thumbnail').click();
              } else if (this.getAttribute('name') == 'previous' && this.prevThumb) {
                  this.prevThumb.querySelector('.thumbnail').click();
              }
          });
      }
      
      init(){
          this.activeButton = this.thumbnailList.querySelector('.thumbnail[aria-current="true"]');
          this.activeItem = this.activeButton.parentElement;
          this.activeItemPosition = parseInt(this.activeItem.dataset.mediaPosition);
          this.nextThumb = null;
          this.prevThumb = null;
          let visibleThumbs = this.getVisibleThumbs();
          const activeIndex = visibleThumbs.findIndex(thumb => thumb === this.activeItem)
          this.prevThumb = visibleThumbs[activeIndex - 1];
          this.nextThumb = visibleThumbs[activeIndex + 1];
          
          if (this.getAttribute('name') == 'previous') {
              this.prevThumb ? this.removeAttribute('disabled') : this.setAttribute('disabled', '');
          } 
          if (this.getAttribute('name') == 'next') {
              this.nextThumb ? this.removeAttribute('disabled') : this.setAttribute('disabled', '');
          }
      }
    
      getVisibleThumbs() {
          let visibleThumbs = Array.from(this.thumbnails).filter((thumbnail, index) => {
              return (thumbnail.dataset.mediaPosition == 1 || !thumbnail.classList.contains('thumbnail-list_item--variant'));
          });
          return visibleThumbs;
      }
    }
  )
}



if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          thumbnailsLeft: this.querySelector('[id^="GalleryThumbnails"] gallery-thumb-nav[name="previous"]'),
          thumbnailsRight: this.querySelector('[id^="GalleryThumbnails"] gallery-thumb-nav[name="next"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          let btn = mediaToSwitch.querySelector('button');
          btn.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        console.log("triggered")
        
        this.elements.thumbnailsLeft.init();
        this.elements.thumbnailsRight.init();

        // if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        const hasThumbnailSlider = this.closest('.product--thumbnail_slider');

        if (hasThumbnailSlider && !isFullyVisible(thumbnail, this.elements.thumbnails)) {
          window.setTimeout(() => {
            (window.matchMedia("(max-width: 749px)").matches) 
              ? this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft })
              : this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop - 5 });
          });
        } 

      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
